import { Component, inject, Input } from '@angular/core';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { Indicator } from '../../../models/indicator';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-full-indicator-name',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './full-indicator-name.component.html',
  styleUrl: './full-indicator-name.component.scss',
})
export class FullIndicatorNameComponent {
  readonly indicatorStore = inject(IndicatorStore);
  @Input() indicator!: Indicator;
  @Input() mode: 'normal' | 'compact' | 'quiet' | 'tooltip' = 'normal';
}
